import PitchResultGroup from '../enums/grouped/PitchResultGroup.js';

const classifyAsSwing = PitchResultGroup.swings.results;

const classifiesAsSwing = function(taggedPitchResultKey){
    if (typeof taggedPitchResultKey !== 'string'){
        return false;
    }

    return classifyAsSwing.indexOf(taggedPitchResultKey) > -1;
};

export default classifiesAsSwing;